import * as React from "react";

import ReportDetail from "../../Reports/ReportDetail";
import type { WorkspaceCreateContext } from "../../../../types/workspace";

export type WorkspaceReportDrawerContentProps = {
  reportId: string;
  workspaceSimulationContext?: WorkspaceCreateContext;
  resolveWorkspacePolicyAttach?: (
    backtestId: string
  ) => WorkspaceCreateContext | null | undefined;
  onWorkspaceSimulationSaved?: (backtestId: string) => void | Promise<void>;
  /** After Save as policy version — backtestId when known (for canvas policy hydrate). */
  onStrategyVersionSaved?: (backtestId?: string) => void | Promise<void>;
  onDeleted?: () => void;
  onClose?: () => void;
};

export function WorkspaceReportDrawerContent({
  reportId,
  workspaceSimulationContext,
  resolveWorkspacePolicyAttach,
  onWorkspaceSimulationSaved,
  onStrategyVersionSaved,
  onDeleted,
  onClose,
}: WorkspaceReportDrawerContentProps): React.ReactElement {
  return (
    <div data-workspace-report-drawer="" className="flex min-h-full min-w-0 flex-1 flex-col">
      <ReportDetail
        layout="embedded"
        reportId={reportId}
        workspaceSimulationContext={workspaceSimulationContext}
        resolveWorkspacePolicyAttach={resolveWorkspacePolicyAttach}
        onWorkspaceSimulationSaved={onWorkspaceSimulationSaved}
        onStrategyVersionSaved={onStrategyVersionSaved}
        onDeleted={onDeleted}
        onClose={onClose}
      />
    </div>
  );
}
